// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"Skeleton_skeleton__28QWG","color-change-2x":"Skeleton_color-change-2x__3kWJW","center":"Skeleton_center__345Zw"};